export function modulosError (state, payload){
    state.error = true
    state.errorMessage = payload
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}

export function setModulos(state, payload){
    state.modulos = payload.data.modulos
    state.error= false
    state.errorMessage = ''
}

export function flushModulos(state){
    state.modulos = []
    state.error= false
    state.errorMessage = ''
}
